import React from 'react';
import CompanyInformation from './company-information';
import OtherTab from './other-tab';
import TabLayout from '../tab-layout/tab-layout';
import PageLayout from '../page-layout/page-layout';

//import { useTheme } from '@emotion/react';
const Settings = () => {
  return (
    <PageLayout
      label='Settings'
      content='Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
            been the industry&aposs standard dummy text ever since the 1500s, when an unknown printer
            took a galley of type and scrambled it to make a type specimen book'
    >
      <TabLayout
        tabs={[
          { name: 'Company Info', element: <CompanyInformation /> },
          { name: 'Other', element: <OtherTab /> }
        ]}
      />
    </PageLayout>
  );
};

export default Settings;
